import React, { Component } from 'react';
import moment from 'moment-timezone';
import { Link } from 'react-router-dom';
import { ReturnTimeZone } from '../../../helpers';
import Tooltip from 'reactstrap/lib/UncontrolledTooltip';
import './LandingCalendar.css';

class LandingCalendar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            calendarDays: [],
            isLoggedInUser: false,
            localUTC: moment().utc()
        }
    }

    componentDidMount() {
        this.generateCalendarDays();
    }

    componentWillReceiveProps(props) {
        if(props.user && !this.state.isLoggedInUser){
            this.setState({
                isLoggedInUser: (this.props.user.role === 'box-office' || this.props.user.role == 'client')
            });
        }
    }

    generateCalendarDays = () => {
        let dates = this.props.event.event_dates;
        let hasDates = dates.length > 0;
        let days = [];
        let startDate = this.generateCalendarStartDate(dates, hasDates);
        let endDate = this.generateCalendarEndDate(dates, hasDates);
        let totalDays = this.generateCalendarTotalDays(hasDates, startDate, endDate);

        // first day of calendar
        days.push(startDate);
        // next days of calendar
        for (let i = 1; i <= totalDays; i++) {
            days.push(moment(startDate).add(i, 'days'));
        }

        // If VOD, only show one date
        if (this.props.event.event_type === 'Video On Demand') {
            days = [];
            let eventDate = this.generateCalendarEventDate(dates, hasDates);
            days.push(moment(eventDate));
        }

        this.setState({ calendarDays: days });
    };

    generateCalendarStartDate = (dates, hasDates) => {
        let timezone = (hasDates) ? ReturnTimeZone(dates[0].timezone || 'EST') : "";
        let startDate = (hasDates)
            ? moment(dates[0].event_datetime_local.substring(0, 19)).tz(timezone)
            : moment();
            
        // make start date a Monday - if it isn't
        if(startDate.format('dddd') === "Sunday") {
            startDate = moment(startDate).weekday(-6);
            
        } else if(startDate.format('dddd') !== "Monday") {
            startDate = moment(startDate.day("Monday"));
        }

        // Event landing page calendar #1725 - Tokyo timezone show not appearing when on Sunday
        if (timezone === 'Asia/Tokyo' && startDate.format('dddd') === "Monday") {
            startDate = moment(startDate.day("Sunday"));
        }
        if (timezone === 'Pacific/Guam' && startDate.format('dddd') === "Monday") {
            startDate = moment(startDate.day("Sunday"));
        }
        return startDate;
    };

    generateCalendarEventDate = (dates, hasDates) => {
        let timezone = (hasDates) ? ReturnTimeZone(dates[0].timezone || 'EST') : "";
        let eventDate = (hasDates)
            ? moment(dates[0].event_datetime_local.substring(0, 19)).tz(timezone)
            : moment();

        // make start date a Monday - if it isn't
        return eventDate;
    };

    generateCalendarEndDate = (dates, hasDates) => {
        let timezone = (hasDates) ? ReturnTimeZone(dates[dates.length-1].timezone || 'EST') : "";
        let endDate = (hasDates)
            ? moment(dates[dates.length-1].event_datetime_local.substring(0, 19)).tz(timezone)
            : null;

        // Event landing page calendar #1725 - Tokyo timezone show not appearing when on Sunday
        if (timezone === 'Asia/Tokyo' && endDate.format('dddd') === "Monday") {
            endDate = moment(endDate.day("Sunday"));
        }
        if (timezone === 'Pacific/Guam' && endDate.format('dddd') === "Monday") {
            endDate = moment(endDate.day("Sunday"));
        }

        // for multiple dates calendar, make end date a Sunday - if it isn't
        if(hasDates && endDate.format('dddd') !== "Sunday") {
            endDate = endDate.day("Sunday").add(7, 'days');
        }

        return endDate;
    };

    generateCalendarTotalDays = (hasDates, startDate, endDate) => {
        let totalDays = (hasDates)
            ? endDate.startOf('day').diff(startDate.startOf('day'), 'days', false)
            : 6;

        if(totalDays < 6) {
            totalDays = 6;
        }

        return totalDays;
    };

    renderCalendarDay = (day, calendarDayIndex) => {
        const dayInWeek = moment(day).format('ddd');
        const dateShort = moment(day).format('MMM Do');
        const showsOfSingleDay = this.getShowsOfSingleDay(day);
        const hasShows = showsOfSingleDay.length > 0;

        return (
            <div
                key={`calendar-day-${calendarDayIndex}`}
                className={(this.props.event.event_type === 'Video On Demand' ? "col-sm-12 showtix-event__calendar-day-vod" : "col-sm-6 col-md-4 col-lg-12") + " showtix-event__calendar-day" + (!hasShows ? ' no-show' : '')}
            >
                {this.props.event.event_type !== 'Video On Demand' && (
                    <div className="showtix-event__calendar-day-header">
                        <p className="showtix-event__calendar-day-dayInWeek">
                            {dayInWeek}
                        </p>
                        <p className="showtix-event__calendar-day-dateShort">
                            {dateShort}
                        </p>
                    </div>
                )}

                <div className="showtix-event__calendar-day-body">
                { hasShows ? (
                    <React.Fragment>
                        {
                            showsOfSingleDay.map((singleShow, singleShowIndex) => {
                                return ([
                                    this.renderDayShow(singleShow, singleShowIndex, calendarDayIndex),
                                ]);
                            })
                        }
                    </React.Fragment>
                ) : (
                    <p className="showtix-event__calendar-day-noShow">&nbsp;</p>
                )}
                </div>
            </div>
        );
    };

    getShowsOfSingleDay = (day) => {
        let sameDayShows = [];

        //console.log('------------------------day', moment(day).format('ddd'));
        this.props.event.event_dates.map((date) => {
            let timezone = ReturnTimeZone(date.timezone || 'EST');
            //console.log('day WITH TIMEZONE', moment(day).tz(timezone).format('ddd'));
            //console.log('/////////');
            //console.log('EVENT DATE', moment(date.event_datetime_local).format('ddd'));
            //console.log('EVENT DATE with TIMEZONE', moment(date.event_datetime_local).tz(timezone).format('ddd'));
            //console.log('EVENT DATE with TIMEZONE and Substring', moment(date.event_datetime_local.substring(0, 19)).tz(timezone).format('ddd'));

            // Event landing page calendar #1417
            let isSameDate = moment(day).isSame(moment(date.event_datetime_local).tz(timezone), 'day');

            // If VOD and fix Patron VOD Rent button #1405
            if (this.props.event.event_type === 'Video On Demand') {
                isSameDate = moment(day).isSame(moment(date.event_datetime_local.substring(0, 19)).tz(timezone), 'day');
            }

            //console.log('isSameDate', isSameDate);

            if (isSameDate) {
                sameDayShows.push(date);
            }
        });
        return sameDayShows;
    };

    renderLabel = (event_type, singleShow, dateString) => {
        switch(event_type) {
            case 'Video On Demand':
            return (
                <React.Fragment>
                    Rent Video (48 hrs)<br />
                    {singleShow.event_subtitle}
                </React.Fragment>
            );
            break;

            case 'Scheduled Content':
            return (
                <React.Fragment>
                    Buy Stream - {dateString}
                </React.Fragment>
            );
            break;

            case 'Live Stream':
            return (
                <React.Fragment>
                    Buy Stream - {dateString}
                </React.Fragment>
            );
            break;

            case 'Event':
            return (
                <React.Fragment>
                    {dateString}
                </React.Fragment>
            );
            break;

            default:
            return (
                <React.Fragment>
                    {dateString}
                </React.Fragment>
            );
            break;
        }
    }

    renderDayShow = (singleShow, singleShowIndex, calendarDayIndex) => {
        let timezone = ReturnTimeZone(this.props.event.venue.timezone || 'EST');
        let localUTC = moment().utc();
        let venueDateTimeUTCSaleStart = moment(singleShow.sale_start).tz(timezone);
        let venueDateTimeUTCSaleEnd = moment(singleShow.sale_end).tz(timezone);
        let venueDateTimeUTCPresaleStart = moment(singleShow.presale_start).tz(timezone);
        let venueDateTimeUTCPresaleEnd = moment(singleShow.presale_end).tz(timezone);
        let dateString = '';
        if (singleShow.event_datetime_local) {
            if (moment(singleShow.event_datetime_local).tz(timezone)) {
                dateString = moment(singleShow.event_datetime_local.substring(0, 19)).format('hh:mm A').toString();
            }
        }
        let isInactive =
            (!localUTC.isBetween(venueDateTimeUTCSaleStart, venueDateTimeUTCSaleEnd))
        && (!localUTC.isBetween(venueDateTimeUTCPresaleStart, venueDateTimeUTCPresaleEnd))
        && singleShow.is_unlocked !== true;

        // states
        let stateDatePresaleStarts = this.renderDatePresaleStarts(singleShow, singleShowIndex, calendarDayIndex);
        let stateDateNotAvailable = this.renderDateNotAvailable(singleShow, singleShowIndex, calendarDayIndex);
        let stateDateDateLabel = this.renderDateLabel(singleShow, singleShowIndex, calendarDayIndex);
        let stateDateUnlocked = this.renderDateUnlocked(singleShow, singleShowIndex, calendarDayIndex);
        let hasTooltip = typeof stateDatePresaleStarts !== 'undefined' || typeof stateDateNotAvailable !== 'undefined' || typeof stateDateDateLabel !== 'undefined';

        if((this.state.isLoggedInUser)) {
            return (
                <React.Fragment>
                    <span
                        key={`single-show-${calendarDayIndex}-${singleShowIndex}`}
                        id={`single-show-${calendarDayIndex}-${singleShowIndex}`}
                        className={"showtix-event__calendar-day-btn showtix-button showtix-background__primary-2 client-inactive " + (isInactive ? ' inactive' : '')}
                    >
                        {this.renderLabel(this.props.event.event_type, singleShow, dateString)}
                        {stateDateUnlocked}

                        {
                            this.renderAllStates(
                                hasTooltip,
                                calendarDayIndex,
                                singleShowIndex,
                                stateDatePresaleStarts,
                                stateDateNotAvailable,
                                stateDateDateLabel
                            )
                        }
                    </span>
                    {this.renderVodAvailability(this.props.event.event_type, singleShow, this.props.event.venue.timezone)}
                </React.Fragment>
            );
        } else {
            if(!isInactive) {
                return (
                    <React.Fragment>
                        <Link
                            key={`single-show-${calendarDayIndex}-${singleShowIndex}`}
                            id={`single-show-${calendarDayIndex}-${singleShowIndex}`}
                            to={`/events/${this.props.event.client_id}/?event=${this.props.event.id}&date=${singleShow.id}`}
                            className={"showtix-event__calendar-day-btn showtix-button showtix-background__primary-2 " + (isInactive ? ' inactive' : '')}
                        >
                            {this.renderLabel(this.props.event.event_type, singleShow, dateString)}
                            {/* this.props.event.event_type === 'Video On Demand' ? (
                                <React.Fragment>
                                    Click to Rent (48 hrs)
                                    {singleShow.subtitle}
                                </React.Fragment>
                            ) : (
                                <React.Fragment>
                                    {dateString}
                                </React.Fragment>
                            ) */}
                            
                            {stateDateUnlocked}
                            {
                                this.renderAllStates(
                                    hasTooltip,
                                    calendarDayIndex,
                                    singleShowIndex,
                                    stateDatePresaleStarts,
                                    stateDateNotAvailable,
                                    stateDateDateLabel
                                )
                            }
                        </Link>
                        {this.renderVodAvailability(this.props.event.event_type, singleShow, this.props.event.venue.timezone)}
                    </React.Fragment>
                );
            } else {
                return (
                    <React.Fragment>
                        <span
                            key={`single-show-${calendarDayIndex}-${singleShowIndex}`}
                            id={`single-show-${calendarDayIndex}-${singleShowIndex}`}
                            className={"showtix-event__calendar-day-btn showtix-button showtix-background__primary-2 "+ (isInactive ? ' inactive' : '')}
                        >
                            {this.renderLabel(this.props.event.event_type, singleShow, dateString)}
                            {stateDateUnlocked}
                            {
                                this.renderAllStates(
                                    hasTooltip,
                                    calendarDayIndex,
                                    singleShowIndex,
                                    stateDatePresaleStarts,
                                    stateDateNotAvailable,
                                    stateDateDateLabel
                                )
                            }
                        </span>
                        {this.renderVodAvailability(this.props.event.event_type, singleShow, this.props.event.venue.timezone)}
                    </React.Fragment>
                );
            }
        }
    };

    renderVodAvailability = (eventType, singleShow, timezone) => {
        if (eventType === 'Video On Demand') {
            return (
                <div className="mt2">
                    Video available to view&nbsp;
                    {moment(singleShow.redeem_start).tz(timezone).format('LLLL')} -&nbsp;
                    {moment(singleShow.redeem_end).tz(timezone).format('LLLL')}&nbsp;
                    {moment().tz(timezone).format('z')}
                </div>
            );
        }
    };

    renderAllStates = (hasTooltip, calendarDayIndex, singleShowIndex, stateDatePresaleStarts, stateDateNotAvailable, stateDateDateLabel) => {
        if(hasTooltip) {
            return (
                <Tooltip placement="top" target={`single-show-${calendarDayIndex}-${singleShowIndex}`} className="single-show-tooltip">
                    {stateDatePresaleStarts}
                    {stateDateNotAvailable}
                    {stateDateDateLabel}
                </Tooltip>
            );
        }
    };

    renderDatePresaleStarts = (singleShow) => {
        let timezone = ReturnTimeZone(this.props.event.venue.timezone || 'EST');
        let timeStringPreSaleStart = undefined;
        if (singleShow.presale_start) {
            timeStringPreSaleStart = singleShow.presale_start.substring(0, 16).replace('T', ' ');
        }
        let timeStringPreSaleEnd = undefined;
        if (singleShow.presale_end) {
            timeStringPreSaleEnd = singleShow.presale_end.substring(0, 16).replace('T', ' ');
        }
        let venueDateTimeUTCPreSaleStart = moment(singleShow.presale_start).tz(timezone);
        let venueDateTimeUTCPreSaleEnd = moment.tz(timeStringPreSaleEnd, timezone);
        
        if (singleShow.presale_password !== '' && this.state.localUTC.isBetween(venueDateTimeUTCPreSaleStart, venueDateTimeUTCPreSaleEnd)) {
        //if (singleShow.presale_password !== '' && this.state.localUTC.isBefore(venueDateTimeUTCPreSaleStart) && !moment(timeStringPreSaleStart).isSame(timeStringPreSaleEnd) ) {
            return (
                <p className="state-message">
                    {this.props.strings.presaleStart}
                    {moment(singleShow.presale_start).tz(timezone).format('LLLL')}
                </p>
            );
        }
    };

    renderDateNotAvailable = (singleShow) => {
        let timezone = ReturnTimeZone(this.props.event.venue.timezone || 'EST');
        let timeStringSaleStart = moment(singleShow.sale_start).tz(timezone).format().toString().substring(0, 19).replace('T', ' ');
        let venueDateTimeUTCSaleStart = moment(singleShow.sale_start).tz(timezone);
        let venueDateTimeUTCSaleEnd = moment(singleShow.sale_end).tz(timezone);

        if(!this.state.localUTC.isBetween(venueDateTimeUTCSaleStart, venueDateTimeUTCSaleEnd)){
            // patrons only
            if(this.state.localUTC.isAfter(venueDateTimeUTCSaleEnd)){
                if(!this.state.isLoggedInUser) {
                    return (
                        <p className="state-message">
                            {this.props.strings.notAvailable}
                        </p>
                    );
                }
            // everyone
            } else {
                return (
                    <p className="state-message">
                        {this.props.strings.salesStart}
                        {moment.utc(timeStringSaleStart).format('LLLL')}
                    </p>
                );
            }
        }
    };

    renderDateLabel = (singleShow) => {
        let timezone = ReturnTimeZone(this.props.event.venue.timezone || 'EST');
        let venueDateTimeUTCSaleEnd = moment.tz(singleShow.sale_end, timezone);
        let publicSaleHaveEnded = this.state.localUTC.isAfter(venueDateTimeUTCSaleEnd);

        // logged-in user
        if(this.state.isLoggedInUser) {
            if(publicSaleHaveEnded) {
                return (
                    <p className="state-message">
                        {this.props.strings.publicSaleEnded}
                    </p>
                );
            }
        }
    };

    renderDateUnlocked = (singleShow) => {
        let timezone = ReturnTimeZone(this.props.event.venue.timezone || 'EST');
        let venueDateTimeUTCPreSaleStart = moment.tz(singleShow.presale_start, timezone);
        let venueDateTimeUTCPreSaleEnd = moment.tz(singleShow.presale_end, timezone);

        if (singleShow.presale_password !== "" && this.state.localUTC.isBetween(venueDateTimeUTCPreSaleStart, venueDateTimeUTCPreSaleEnd) && singleShow.is_unlocked !== true){
            if (this.state.isLoggedInUser) {
                return (
                    <React.Fragment>
                        <br />
                        <span className="showtix-badge showtix-background__primary-4 position-relative">{this.props.strings.presale} - ({singleShow.presale_password})</span>
                    </React.Fragment>
                )
            }
        }
    };

    renderCalendar = () => {
        return (
            this.props.event.event_dates.length > 0 &&
                <div className="showtix-event__calendar-days">
                    <div className="row">
                        {this.state.calendarDays.map((day, i) =>
                            this.renderCalendarDay(day, i)
                        )}
                    </div>
                </div>
        );
    };

    render() {
        let timeZoneOffset = '';
        if (this.props.event.event_type === 'Live Stream' || this.props.event.event_type === 'Scheduled Content') {
            timeZoneOffset = new Date(this.props.event.event_dates[0].event_datetime_local).getTimezoneOffset();
        }
        
        return (
            <div className="showtix-event__calendar">
                <h1>{this.props.event.event_type}</h1>
                {this.renderCalendar()}
                {timeZoneOffset !== '' && (
                    <span className="showtix-timezone">Times are in {moment.tz.zone(this.props.event.venue.timezone).abbr(timeZoneOffset)}</span>
                )}
            </div>
        );
    }
}

LandingCalendar.propTypes = {
    
}

export default LandingCalendar;


// WEBPACK FOOTER //
// ./src/components/EventLanding/LandingCalendar/LandingCalendar.js